<script setup>
import { storeToRefs } from 'pinia';

// // Store management imports
// import { useBreakStore } from '@/stores/break';
import { useDirectionStore } from '@/stores/direction';
// import { useGeneralStore } from '@/stores/general';

// // Template imports
import TempTwoSmallProducts from './TempTwoSmallProducts.vue';

const { directionModule } = storeToRefs(useDirectionStore());

// // FourthWall functions

const callDirectionModule = () => {
  return directionModule.value;
};
</script>

<template>
  <main class="fourth-wall">
    <div class="fourth-wall__container">
      <TempTwoSmallProducts v-if="callDirectionModule() === 'TempTwoSmallProducts'" />
    </div>
  </main>
</template>

<style lang="scss">
@use './fourthwall.scss';
</style>
